import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import axios from 'axios'
import 'element-ui/lib/theme-chalk/index.css'

axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? '' : 'http://127.0.0.1:5000'
Vue.prototype.$axios = axios

Vue.use(ElementUI)
Vue.config.productionTip = false

// Create Vue instance immediately to avoid black screen
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

// Load site title asynchronously (don't block rendering)
axios.get('/admin/site-basic')
  .then(response => {
    if (response.data && response.data.data && response.data.data.siteTitle) {
      document.title = response.data.data.siteTitle
    }
  })
  .catch(() => {})